import useAccount from '@ubeya/shared/hooks/account/useAccount';
import { PAYMENT_PERIOD_TYPE_WEEK } from '@ubeya/figaro/src/crm/constants';
import moment from 'moment/moment';
import { useState } from 'react';

export const useAccountTimeRange = () => {
  const { account } = useAccount();
  const payrollByWeek = account?.payrollConfig?.paymentPeriodType === PAYMENT_PERIOD_TYPE_WEEK;

  const start = payrollByWeek
    ? moment().subtract(1, 'week').startOf('week')
    : moment().subtract(1, 'month').startOf('month');
  const end = payrollByWeek ? moment().subtract(1, 'week').endOf('week') : moment().subtract(1, 'month').endOf('month');

  return useState({
    key: payrollByWeek ? 'lastWeek' : 'lastMonth',
    start,
    end
  });
};
